import React, { Dispatch } from 'react'
import styled from 'styled-components'
import { TrialMode, useHandleClick, useIsDisabled } from './hooks'
import { UiState } from '../../../types'

type Props = {
  buttonTitle: string
  trialMode: TrialMode
  isConsulRequestChecked: boolean
  setShowSpinner: Dispatch<React.SetStateAction<boolean>>
  marketoFormRef: React.RefObject<HTMLFormElement>
  uiState: UiState
  setUiState: Dispatch<React.SetStateAction<UiState>>
}

export const SubmitButton: React.FC<Props> = props => {
  const handleClick = useHandleClick(
    props.trialMode,
    props.isConsulRequestChecked,
    props.setShowSpinner,
    props.marketoFormRef,
    props.uiState,
    props.setUiState
  )
  const isDisabled = useIsDisabled(props.isConsulRequestChecked, props.uiState)

  return (
    <Button onClick={handleClick} disabled={isDisabled}>
      {props.buttonTitle}
    </Button>
  )
}

const Button = styled.button`
  width: 100%;
  height: 48px;
  background: #20aee5;
  box-shadow: 0px 1px 0px #1987b3;
  border-radius: 4px;
  border: 0.5px #1987b3 solid;
  text-align: center;
  color: white;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`
